import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-info',
  templateUrl: './invoice-info.component.html',
  styles: []
})
export class InvoiceInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
